import { render, staticRenderFns } from "./shenbaoAdd.vue?vue&type=template&id=aebf1972&scoped=true"
import script from "./shenbaoAdd.vue?vue&type=script&lang=js"
export * from "./shenbaoAdd.vue?vue&type=script&lang=js"
import style0 from "./shenbaoAdd.vue?vue&type=style&index=0&id=aebf1972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebf1972",
  null
  
)

export default component.exports